// Placeholder suffixes for the preview toggle of campaign types that have no real template suffix
// (Price, URL): gx-preview.js keys its internal state by these suffix strings, so they must be
// non-empty and distinct.
export const DESTINATION_PREVIEW_SUFFIX = {
  CONTROL: 'control',
  VARIANT: 'variant',
} as const;
